module.exports = __webpack_public_path__ + "static/media/c1.09df7b3d.png";